import React, { useEffect, useState } from "react";
import * as R from "ramda";
import Modal from "react-bootstrap/Modal";
import { useTranslation } from "react-i18next";
import styled, { css } from "styled-components";
import PhotoSelect from "./PhotoSelect";
import twoColumns from "../../images/2C_Thumbnail_View.png";
import twoColumnsSelected from "../../images/2C_Thumbnail_View_Selected.png";
import threeColumns from "../../images/3C_Thumbnail_View.png";
import threeColumnsSelected from "../../images/3C_Thumbnail_View_Selected.png";
import { SortUp, SortDown } from "react-bootstrap-icons";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import { validateValue } from "../../utils/utils";
import { Select } from "antd";
import { getPhotoForUserId } from "../../utils/utils";
import DeviceOrientation, { Orientation } from "react-screen-orientation";
import { Link } from "react-router-dom";
import { Spin, Button as AntButton } from "antd";
import ConfirmDelete from "../ui/ConfirmDelete";
import { AutoComplete } from "antd";

const ContainerMod = styled.div`
  display: flex;
  flex-direction: ${(props) => (props.view === "one" ? "row" : "column")};
  justify-content: start;
  padding: 0;
  margin-bottom: 2vh;
  min-width: ${(props) =>
    props.view === "three"
      ? "31%"
      : props.view === "two"
      ? "48%"
      : props.view === "one"
      ? "98%"
      : "98%"};
  width: ${(props) =>
    props.view === "three"
      ? "31%"
      : props.view === "two"
      ? "48%"
      : props.view === "one"
      ? "98%"
      : "98%"};
  height: unset;
  aspect-ratio: ${(props) => (props.isGallery ? "261 / 156" : "260 / 106")};
  margin: 1%;

  @media only screen and (max-width: 768px) {
    width: 98%;
    min-width: 98%;
  }

  @media only screen and (min-width: 1024px) and (max-height: 1366px) and (orientation: portrait) and (-webkit-min-device-pixel-ratio: 1.5) {
    width: 68%;
    min-width: 68%;
  }

  @media only screen and (min-width: 768px) and (max-width: 992px) and (orientation: portrait) {
    width: 68%;
    min-width: 68%;
  }
`;

const SelectStyle = styled.div`
  margin-right: 0;

  @media only screen and (max-width: 450px) and (orientation: portrait) {
    margin-right: 0;
    margin-bottom: 0.5em;
  }

  @media only screen and (max-width: 768px) {
    margin-right: 0;
    margin-bottom: 0.5em;
  }
`;

const CardDeckContainer = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  padding: 0;
  width: 90%;
  overflow-y: auto;

  ${(props) =>
    props.portrait &&
    css`
      display: none;
    `};
`;

const ButtonViewStyles = styled.div`
  text-align: end;
  order: 6;

  @media only screen and (max-width: 768px) {
    display: none;
    max-width: 84vw;
  }

  @media only screen and (max-width: 900px) and (orientation: portrait) {
    display: none;
  }
  @media only screen and (max-width: 450px) and (orientation: portrait) {
    display: none;
  }
`;

const FilterContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 10px;
  margin-bottom: 10px;

  @media only screen and (max-width: 768px) {
    justify-content: center;
  }
`;

const FloatingLabelOrderBy = styled(FloatingLabel)`
  & label {
    color: #00297a !important;
    transform: scale(0.65) translateY(-1rem) translateX(0.15rem);
  }

  font: normal normal bold 20px / 28px Lato;
  letter-spacing: 0px;
  opacity: 1;
  font-weight: 700;
  order: 1;
  flex: 5;
`;

const Image = styled.img`
  width: 18px;
  height: 18px;
  background: none;
  text-align: center;
  vertical-align: middle;
`;

const Button = styled.button`
  display: inline-block;
  margin: 0.5rem 0;
  width: 50px;
  height: 55px;
  background: #e6e6e6;
  font: normal normal 600 12px/18px Poppins;
  font-weight: 700;
  text-align: center;
  padding: 0;
  vertical-align: bottom;
  text-transform: uppercase;

  ${(props) =>
    props.primary &&
    css`
      border-radius: 7px;
      width: 130px;
      font: normal normal 600 32px var(--unnamed-font-family-poppins);
      font-weight: 700;
      color: #ffffff;
      opacity: 1;
      letter-spacing: 0px;

      @media only screen and (max-width: 900px) and (orientation: portrait) {
        text-align: center;
        font: normal normal 600 32px/48px Poppins;
        width: 70px;
        padding: 0;
      }
      @media only screen and (max-width: 450px) and (orientation: portrait) {
        padding: 0;
        margin: 0;
        width: 68px;
      }
    `}
  ${(props) =>
    props.left &&
    css`
      border-radius: 8px 0px 0px 8px;
      margin: 0.5rem 0;
    `}
    ${(props) =>
    props.right &&
    css`
      border-radius: 0px 8px 8px 0px;
      margin: 0.5rem 0.01rem;
      width: 53px;
    `}
    ${(props) =>
    props.reduceSize &&
    css`
      font: var(--unnamed-font-style-normal) normal 600
        var(--unnamed-font-size-12) / 15px var(--unnamed-font-family-poppins);
      font: normal normal 600 11px/15px Poppins;
    `}
`;

const ButtonAdd = styled.button`
  background: #00297a 0% 0% no-repeat padding-box;
  border-color: #00297a;
  border-radius: 10px;
  margin-top: 20px;
  opacity: 1;
  width: 150px;
  height: 48px;
  font-weight: 500;
  color: #ffffff;

  &:hover {
    background: #00187e;
    border-color: #00187e;
  }
  @media (max-width: 768px) {
    margin-top: 10px;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: ${(props) => (props.reverse ? "row-reverse" : "row")};
  align-items: center;
  justify-content: center;
`;

const SelectOrderArsenal = styled(Select)`
  width: 100%;
  height: 48px;

  & .ant-select-selector {
    height: 48px !important;
    overflow: visible !important;
  }

  & .ant-select-arrow {
  }

  &.arsenal-select .ant-select-selector {
    overflow: auto;
    padding-top: 2px;
  }

  &.arsenal-select .ant-select-selector .ant-select-selection-item {
    line-height: 48px !important;
  }

  &.arsenal-select
    .ant-select-selector
    .ant-select-selection-overflow-item
    .ant-select-selection-item {
    line-height: 24px !important;
  }
`;

const thumbnailStyle = {
  width: "18px",
  height: "18px",
};

const StyledModal = styled(Modal)`
  .modal-content {
    min-height: 100%;
  }
`;

const StyledAutoComplete = styled(AutoComplete)`
  .ant-select-selection-search-input {
    height: 48px !important;
  }
`;

const GalleryModal = (props) => {
  const {
    showGalleryModal,
    setShowGalleryModal,
    gallery,
    setCustomerGallery,
    srcToShowDefault = "",
    showModalDefault = false,
    ogSRCDefault = "",
    imageIndexDefault = 0,
    setCustomerGalleryTag,
    deleteCustomerGallery,
    userId,
    customerID,
  } = props;
  const [addingFile, setAddingFile] = useState(false);
  const [showModal, setShowModal] = useState(showModalDefault);
  const [showConfirmDeleteFile, setShowConfirmDeleteFile] = useState(false);
  const [temporalOrderDirection, setTemporalOrderDirection] = useState("desc");
  const [filterField, setFilterField] = useState(0);
  const [tagFilter, setTagFilter] = useState("");
  const [srcToShow, setSrcToShow] = useState(srcToShowDefault);
  const [ogSrc, setOgSrc] = useState(ogSRCDefault);
  const [loading, setLoading] = useState(false);
  const [imageIndexSelected, selectImageIndex] = useState(imageIndexDefault);
  const filterArray1 = ["", ".png", ".mov"];
  const filterArray2 = ["", ".jpeg", ".mp4"];
  const filterArray3 = ["", ".jpg", ".mp4"];
  const [show, setShow] = useState("three");
  const srcToCheck = srcToShow?.toLowerCase().split("?")[0] || "";
  const isVideo =
    srcToCheck.includes("data:video") ||
    ["mp4", "mov"].includes(srcToCheck.split(".").pop());
  const { t } = useTranslation();
  const getPhoto = getPhotoForUserId(userId);
  const handleFilterField = (field) => {
    setFilterField(field);
  };
  const handleTagFilterField = (field) => {
    setTagFilter(field);
  };

  const handleViewChange = (e) => {
    if (validateValue(e.target.value) !== "") {
      setShow(e.target.value);
    } else if (validateValue(e.target.id) !== "") {
      setShow(e.target.id);
    }
  };

  let galleryFiltered = !R.isEmpty(filterField)
    ? gallery?.filter(
        (src) =>
          src?.endsWith(filterArray1[filterField]) ||
          src?.endsWith(filterArray2[filterField]) ||
          src?.endsWith(filterArray3[filterField])
      )
    : [];

  galleryFiltered = galleryFiltered?.sort();
  if (temporalOrderDirection === "desc") {
    galleryFiltered = galleryFiltered?.reverse();
  }

  useEffect(() => {
    if (galleryFiltered?.length !== undefined) {
      setLoading(false);
    }
  }, [galleryFiltered?.length]);

  const DeleteModal = (props) => {
    const { src } = props;
    const srcToCheck = src?.split("?")[0] || "";
    const isImage =
      srcToCheck?.includes("data:image") ||
      ["png", "jpeg, jpg"].includes(srcToCheck.split(".").pop());
    const isVideo =
      srcToCheck?.includes("data:video") ||
      ["mp4", "mov"].includes(srcToCheck.split(".").pop());

    return (
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        dialogClassName="gallery-popup"
        centered
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <DeviceOrientation>
            <Orientation orientation="landscape">
              <div
                style={{
                  height: "98%",
                  margin: 5,
                }}
              >
                {isImage && (
                  <img
                    src={src}
                    style={{
                      width: "100%",
                      height: "100%",
                      maxHeight: "600px",
                    }}
                  />
                )}
                {isVideo && (
                  <video
                    src={src}
                    style={{
                      width: "100%",
                      height: "100%",
                      maxHeight: "600px",
                    }}
                    autoPlay
                    controls
                  />
                )}
              </div>
            </Orientation>
            <Orientation orientation="portrait">
              <div
                style={{
                  width: "98%",
                  margin: 5,
                }}
              >
                {isImage && (
                  <img
                    src={src}
                    style={{
                      width: "100%",
                      height: "100%",
                      maxHeight: "600px",
                    }}
                  />
                )}
                {isVideo && (
                  <video
                    src={src}
                    style={{
                      width: "100%",
                      height: "100%",
                      maxHeight: "600px",
                    }}
                    autoPlay
                    controls
                  />
                )}
              </div>
            </Orientation>
          </DeviceOrientation>
        </Modal.Body>
        <Modal.Footer>
          {isImage && (
            <Link
              to={`/print/${customerID}/attachment/${imageIndexSelected}`}
              target="_blank"
            >
              <AntButton
                style={{
                  background: "none",
                  fontSize: 12,
                  border: "none",
                  margin: 0,
                  color: "#00197B",
                  boxShadow: "none",
                }}
              >
                {t("Print")}
              </AntButton>
            </Link>
          )}
          <AntButton
            onClick={() => {
              setShowConfirmDeleteFile(true);
            }}
            style={{
              background: "none",
              fontSize: 12,
              border: "none",
              margin: 0,
              color: "#F0142F",
              boxShadow: "none",
            }}
          >
            {" "}
            {isVideo
              ? t("photoSelectModal.deleteVideo")
              : t("photoSelectModal.delete")}
          </AntButton>
        </Modal.Footer>
      </Modal>
    );
  };

  const GalleryCard = ({ src, key, onClick }) => {
    const srcToCheck = src?.toLowerCase().split("?")[0] || "";
    const isImage =
      srcToCheck.includes("data:image") ||
      ["png", "jpg", "jpeg"].includes(srcToCheck.split(".").pop());
    const isVideo =
      srcToCheck.includes("data:video") ||
      ["mp4", "mov"].includes(srcToCheck.split(".").pop());
    const parts = src.split("_");
    const tag = parts[6];
    const date = parts[3];
    const time = parts[4];
    return (
      <div onClick={onClick}>
        <div>#{tag === "" ? t("No tag") : tag}</div>
        <div
          style={{
            height: "auto",
            margin: 5,
          }}
        >
          {isImage && (
            <img
              src={getPhoto(`${src}?ttl=${Date().toString()}`)}
              style={{
                width: "100%",
                height: "100%",
                maxWidth: show === "three" ? "450px" : "650px",
                maxHeight: show === "three" ? "250px" : "350px",
              }}
            />
          )}
          {isVideo && (
            <video
              src={getPhoto(`${src}?ttl=${Date().toString()}`)}
              style={{
                width: "100%",
                height: "90%",
                maxWidth: show === "three" ? "450px" : "650px",
                maxHeight: show === "three" ? "250px" : "350px",
              }}
              controls
            />
          )}
        </div>
        <div>
          {date.slice(0, 4)}/{date.slice(4, 6)}/{date.slice(6, 8)} :{" "}
          {time.slice(0, 2)}:{time.slice(2, 4)}:{time.slice(4, 6)}
        </div>
      </div>
    );
  };

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <StyledModal
        show={showGalleryModal && !addingFile}
        onHide={() => setShowGalleryModal(false)}
        dialogClassName="modal-gallery"
        fullscreen="xl-down"
        scrollable={true}
        style={{ margin: 0, minHeight: "100%" }}
      >
        <Modal.Header
          closeButton
          style={{
            backgroundColor: "#E6E6E6",
            borderBottom: "0 none",
          }}
        >
          <div style={{ marginTop: 10 }}>
            <span
              style={{
                fontSize: 20,
                fontWeight: "bold",
                color: "#00197B",
              }}
            >
              {t("Media Gallery")}
            </span>
          </div>
        </Modal.Header>
        <Modal.Body
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            alignItems: "center",
            backgroundColor: "#E6E6E6",
          }}
        >
          <FilterContainer className="col-12 col-md-12 col-lg-9">
            <SelectStyle className="col-12 col-md-12 col-lg-9">
              <ButtonContainer reverse>
                <FloatingLabelOrderBy
                  label={t("Media Type")}
                  className="arsenal-select-floating-label"
                >
                  <SelectOrderArsenal
                    className="arsenal-select"
                    value={filterField}
                    options={[
                      {
                        value: 0,
                        label: t("All"),
                      },
                      {
                        value: 1,
                        label: t("Image Only"),
                      },
                      {
                        value: 2,
                        label: t("Video Only"),
                      },
                    ]}
                    onChange={handleFilterField}
                    getPopupContainer={(triggerNode) => triggerNode.parentNode} // Render dropdown inside the modal
                  />
                </FloatingLabelOrderBy>
                <FloatingLabelOrderBy
                  label={t("Tag Filter")}
                  className="arsenal-select-floating-label"
                >
                  <StyledAutoComplete
                    value={tagFilter}
                    style={{ width: "100%", height: "48px" }}
                    className="arsenal-select"
                    options={[
                      {
                        value: "",
                      },
                      { value: "Back" },
                      { value: "Release" },
                      { value: "Revs" },
                      { value: "Side" },
                    ]}
                    filterOption={(inputValue, option) =>
                      option.value
                        .toUpperCase()
                        .indexOf(inputValue.toUpperCase()) !== -1
                    }
                    onChange={handleTagFilterField}
                    getPopupContainer={(triggerNode) => triggerNode.parentNode} // Render dropdown inside the modal
                  />
                </FloatingLabelOrderBy>
                <Button
                  sort
                  onClick={() => {
                    if (temporalOrderDirection === "asc") {
                      setTemporalOrderDirection("desc");
                    } else {
                      setTemporalOrderDirection("asc");
                    }
                  }}
                >
                  {temporalOrderDirection === "asc" ? (
                    <SortUp style={{ fontSize: 24, color: "#00297a" }} />
                  ) : (
                    <SortDown style={{ fontSize: 24, color: "#00297a" }} />
                  )}
                </Button>
              </ButtonContainer>
            </SelectStyle>
            <ButtonViewStyles className="col-4 col-md-2 col-lg-2">
              <Button
                onClick={handleViewChange}
                value="three"
                active={show === "three" ? true : false}
              >
                <Image
                  src={show === "three" ? threeColumnsSelected : threeColumns}
                  alt="email logo"
                  id="three"
                />
              </Button>
              <Button
                onClick={handleViewChange}
                value="two"
                active={show === "two" ? true : false}
              >
                <Image
                  style={thumbnailStyle}
                  src={show === "two" ? twoColumnsSelected : twoColumns}
                  alt="email logo"
                  id="two"
                />
              </Button>
            </ButtonViewStyles>
          </FilterContainer>
          <CardDeckContainer>
            {!galleryFiltered || galleryFiltered.length === 0 ? (
              filterField === 0 ? (
                <h1 style={{ width: "100%", textAlign: "center" }}>
                  {t("No Images/Videos Found")}
                </h1>
              ) : filterField === 1 ? (
                <h1 style={{ width: "100%", textAlign: "center" }}>
                  {t("No Images Found")}
                </h1>
              ) : (
                <h1 style={{ width: "100%", textAlign: "center" }}>
                  {t("No Videos Found")}
                </h1>
              )
            ) : (
              galleryFiltered?.map(
                (src, index) =>
                  src?.includes(tagFilter) && (
                    <ContainerMod view={show} isGallery={true}>
                      <GalleryCard
                        src={src}
                        key={index}
                        onClick={() => {
                          setSrcToShow(
                            getPhoto(`${src}?ttl=${Date().toString()}`)
                          );
                          setOgSrc(src);
                          selectImageIndex(index);
                          setShowModal(true);
                        }}
                      />
                    </ContainerMod>
                  )
              )
            )}
          </CardDeckContainer>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              marginBottom: "40px",
            }}
          >
            {!loading && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <ButtonAdd
                  type="submit"
                  onClick={() => {
                    setAddingFile(true);
                    setLoading(true);
                  }}
                >
                  {t("Add File")}
                </ButtonAdd>
                <div
                  style={{
                    fontSize: "10px",
                    marginTop: "10px",
                    opacity: "0.7",
                    textAlign: "center",
                  }}
                >
                  {t(
                    "Disclaimer: The current version of the gallery upload only accepts up to 200 MB per file. We recomend limiting video uploads to 20 seconds and keeping resolution at HD."
                  )}
                </div>
              </div>
            )}{" "}
            {loading && <Spin size="large" />}
          </div>
        </Modal.Body>
      </StyledModal>
      {addingFile && (
        <PhotoSelect
          circle={false}
          show={addingFile}
          includeTag={true}
          showVideo={true}
          onHide={() => {
            setAddingFile(false);
          }}
          onFromCamera={(imageBase64, extension, tag) => {
            setCustomerGallery({
              imageBase64,
              extension: extension || "png",
              tag: tag || "",
            });
            setAddingFile(false);
          }}
          onFromGallery={(imageBase64, extension, tag) => {
            setCustomerGallery({
              imageBase64,
              extension: extension || "png",
              tag: tag || "",
            });
            setAddingFile(false);
          }}
          onFromVideo={(video, extension, tag) => {
            // Fetch the Blob from the Blob URL
            fetch(video)
              .then((response) => response.blob())
              .then((blob) => {
                // Convert the Blob to Base64
                const reader = new FileReader();
                reader.onloadend = () => {
                  const base64data = reader.result.split(";base64,"); // This is the Base64 string
                  setCustomerGallery({
                    imageBase64: base64data[1], // Assign the Base64 string to imageBase64
                    extension: extension || "mp4",
                    tag: tag || "",
                  });
                  setAddingFile(false);
                };
                reader.readAsDataURL(blob); // Read the Blob as a Base64 string
              })
              .catch((error) => {
                console.error("Error converting video Blob to Base64:", error);
                setAddingFile(false);
              });
          }}
        />
      )}
      <DeleteModal
        show={showModal}
        onHide={() => {
          setSrcToShow(getPhoto(""));
          setOgSrc("");
          setShowModal(false);
        }}
        src={srcToShow}
      />
      <ConfirmDelete
        show={showConfirmDeleteFile}
        onHide={() => {
          setShowConfirmDeleteFile(false);
        }}
        confirmButtonText={
          isVideo
            ? "message.confirm.deleteVideo"
            : "message.confirm.deleteImage"
        }
        confirmDescription={
          isVideo
            ? "message.confirm.confirmDeleteVideo"
            : "message.confirm.confirmDeleteImage"
        }
        onConfirmClick={() => {
          deleteCustomerGallery({ fileName: ogSrc }); // Needs the original gallery index
          setShowConfirmDeleteFile(false);
          setSrcToShow(getPhoto(""));
          setOgSrc("");
          setShowModal(false);
          selectImageIndex(-1);
        }}
      />
    </div>
  );
};

export default GalleryModal;
